import * as React from 'react';
import { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSubDomain } from '../../../Auth/utils/AuthUtils.js';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, CssBaseline, TextField, Typography } from '@mui/material';
import config from "../../../../constants/config.json";
import { getTenantByDomain, addGuestDemo } from '../../store/authThunks.js';


const defaultTheme = createTheme();

export default function LoginGuestEmail() {
  const [error, setError] = useState();
  const [success, setSuccess] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const demoToken = urlParams.get("d");
  const { mapId } = useParams();
  const [open, setOpen] = React.useState(true);
  const [email, setEmail] = useState("");
  const emailTrimmed = email.trim();
  const isEmailValid = /^[^\s@]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailTrimmed);
  const canSend = isEmailValid;



  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const subDomain = getSubDomain();
      const tenantResp = await dispatch(
        getTenantByDomain({ params: [{ subDomain }] })
      ).unwrap();
      const fallbackTenantId = tenantResp?.tenant?.id;
      if (!fallbackTenantId) {
        setError("Tenant introuvable");
        return;
      }
      const loginPayload = {
        email,
        expirationTime: 24,
        sendEmail: true,
        anonymous: false,
        source: "platform",
        ...(demoToken
          ? { demoToken }
          : { map_id: mapId, tenant_id: fallbackTenantId }),
      };
      const action = await dispatch(
        addGuestDemo({
          body: loginPayload
        })
      ).unwrap();
      if (action?.newGuestToken) {
        setSuccess(t("invitation_sent_sucess"));
      }
      setEmail("");
    }
    catch (error) {
      setError(error.message);
    }


  };
  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Container width="100vh" sx={{ height: "100vh", overflowY: 'auto' }}>
        <Container component="main" maxWidth="sm">
          <Box
            sx={{
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >

            <img
              src='/LoginAifel.svg'
              style={{
                maxWidth: '300px',
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                marginTop: '10px'
              }}
              alt="Login Logo"
            />
            {!success && (
              <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }} style={{ width: '457px' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  type='email'
                  autoComplete="email"
                  autoFocus
                  variant="standard"
                  value={email} inputProps={{ inputMode: "email", autoComplete: "email" }}
                  error={email.length > 0 && !isEmailValid}
                  helperText={
                    email.length > 0 && !isEmailValid
                      ? (t("invalid_email") || "Adresse e-mail invalide")
                      : " "
                  }
                  InputProps={{
                    disableUnderline: true,
                    sx: {

                      paddingX: 1,
                      paddingY: 1.5,
                    },
                  }}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{
                    '& .MuiInput-underline:before': {
                      borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                      borderRadius: '0 !important',
                    },
                    '& .MuiInput-input': {
                      borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                      borderRadius: '0 !important',
                    },
                    '& .MuiInput-underline:after': {
                      borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                      borderRadius: '0 !important',
                    },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                      borderBottom: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                    },
                    '& .MuiOutlinedInput-root.Mui-focused': {
                      '& fieldset': {
                        borderColor: 'rgba(0, 0, 0, 0.6)',
                      },
                    },
                    '& .MuiFormLabel-asterisk': {
                      color: '#F26969',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'rgba(0, 0, 0, 0.6)',
                      },
                    },
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={!canSend}
                  sx={{
                    mt: 3,
                    mb: 2,
                    backgroundColor: '#77dd48',
                    color: '#0C0C0C',
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    fontStyle: 'normal',
                    lineHeight: 'normal',
                    letterSpacing: 'normal',
                    textTransform: 'math-auto',
                    '&:hover': {
                      backgroundColor: 'var(--peoplmap-primary)'
                    },
                  }}>
                  {t("continue")}
                </Button>
              </Box>)}
            {success && (
              <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }} style={{ width: '457px' }}>
                <Typography variant="h6" gutterBottom>
                  {success}
                </Typography>
              </Box>
            )}
          </Box>
        </Container>
      </Container>
    </ThemeProvider>
  );


}

